import { render, staticRenderFns } from "./RegistroManual.vue?vue&type=template&id=884ab39c&scoped=true"
import script from "./RegistroManual.vue?vue&type=script&lang=js"
export * from "./RegistroManual.vue?vue&type=script&lang=js"
import style0 from "./RegistroManual.vue?vue&type=style&index=0&id=884ab39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884ab39c",
  null
  
)

export default component.exports